import { useEffect } from "react";
import axios from "axios";
import { useLanguage } from "../i18n/LanguageContext";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
const SESSION_KEY = "ns_visit_tracked";

export function useTrackVisit() {
  const { language } = useLanguage();

  useEffect(() => {
    if (!language) return;
    if (sessionStorage.getItem(SESSION_KEY)) return;
    sessionStorage.setItem(SESSION_KEY, "1");
    axios.post(`${API}/analytics/track`, { language, page: window.location.pathname }).catch(() => {});
  }, [language]);
}
